/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/CandidateFileEvent.php */
export const candidateFileEvent = {
	Scanned: 'scanned',
} as const

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/CandidateFileEvent.php */
export type CandidateFileEvent = (typeof candidateFileEvent)[keyof typeof candidateFileEvent]
